import axios, { type AxiosRequestHeaders } from "axios";

import { useUserStore } from "@/stores/userStore";

const baseURL = import.meta.env.VITE_API_BASE_URL;

if (baseURL === undefined) {
  throw new Error(
    "API base URL not found, maybe forgot to set env var VITE_API_BASE_URL?",
  );
}

// Create an Axios instance with the base URL from your environment variables
export const axiosInstance = axios.create({ baseURL });

// Set up a request interceptor to add the Authorization header dynamically
axiosInstance.interceptors.request.use((config) => {
  const state = useUserStore.getState();

  // Ensure headers exist and are properly typed
  config.headers = (config.headers as AxiosRequestHeaders) || {};

  if (state.token) {
    config.headers.Authorization = `Bearer ${state.token}`;
  }
  if (state.role) {
    config.headers["current-role"] = state.role;
    config.headers["X-Auth-Role"] = state.role;
  }

  config.headers["X-Accept-Language"] = "fa";

  return config;
});
